import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  appendOrderChatMessageToCache,
  ORDER_CHAT_SESSIONS_QUERY_KEY,
  ORDER_CHAT_UNREAD_QUERY_KEY,
} from '../chat-cache';
import { useClientOrderChatSocket } from '../hooks/useClientOrderChatSocket';
import { showSupportChatIncomingToast } from '@modules/seller-support-chat/support-chat-toast';

type SellerOrderChatToastListenerProps = {
  enabled?: boolean;
};

/** Тост при новом сообщении в чате по заказу, если пользователь не на странице. */
export function SellerOrderChatToastListener({
  enabled = true,
}: SellerOrderChatToastListenerProps) {
  const queryClient = useQueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const onChatPage = location.pathname.startsWith('/order-chats');

  useClientOrderChatSocket(
    {
      onMessage: ({ message, problemMessageId }) => {
        if (message.senderKind === 'SELLER') return;
        const pid =
          problemMessageId ??
          message.relatedMessageId ??
          (message.systemEvent === 'ORDER_PROBLEM' ? message.id : null);
        if (pid != null) {
          appendOrderChatMessageToCache(queryClient, pid, message);
        }
        queryClient.invalidateQueries({ queryKey: ORDER_CHAT_SESSIONS_QUERY_KEY });
        if (onChatPage) return;
        showSupportChatIncomingToast({
          title: 'Вам пришло сообщение по заказу',
          body: message.body,
          imageCount: message.imageUrls?.length ?? 0,
          messageId: message.id,
          onOpen: () =>
            navigate(
              pid != null
                ? `/order-chats?problemId=${pid}`
                : '/order-chats',
            ),
        });
      },
      onUnread: ({ scope, count }) => {
        if (scope !== 'seller' || onChatPage) return;
        queryClient.setQueryData(ORDER_CHAT_UNREAD_QUERY_KEY, { count });
      },
    },
    enabled && !onChatPage,
  );

  return null;
}
